import React from "react";
import styles from './ToggleButton.module.css';

const ToggleButton = ( { onClick, status } ) =>
{
    
    return (
        <button className={styles.button} onClick={ onClick } >{status ? '-' : '+' }</button>
    )
}

ToggleButton.defaultProps = {};

export default ToggleButton;